import { isChaps } from '../modes/selectors';
import { TYPE_CHAPS } from '../../config';
import { hasExternalPayments } from './hasExternalPayments';

export const getPaymentCategory = (state) => {
	if (isChaps(state)) {
		return TYPE_CHAPS;
	}
	if (hasExternalPayments(state)) {
		return 'BFT';
	}

	return 'IAT';
};
